import axios from "axios";
import { api_url } from "../data";
import { useNavigate } from "react-router-dom";

export const useAuth = () => {
  const navigate = useNavigate();

  const getAccessToken = () => {
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith("accessToken="))
      ?.split("=")[1];
  };

  const getRefreshToken = () => {
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith("refreshToken="))
      ?.split("=")[1];
  };

  const refreshAccessToken = async () => {
    try {
      // get the refresh token first
      const refreshToken = getRefreshToken();
      // call the api endpoint to get a new access token
      const response = await axios.post(`${api_url}/auth/token/refresh/`, {
        "refresh":refreshToken,
      });
      // store the new access token in the cookie
      document.cookie = `accessToken=${
        response.data.access
      }; expires=${new Date(
        new Date().getTime() + 60 * 60 * 1000
      ).toUTCString()}`;
      // return the new access token
      return response.data.access;
    } catch (error) {
      document.cookie = `accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure`;
      navigate("/");
      throw error;
    }
  };

  const requestWithAuth = async (
    url,
    method = "GET",
    data = null,
    headers = {}
  ) => {
    let accessToken = getAccessToken();
    
    try {
      const response = await axios({
        url: `${api_url}${url}`,
        method,
        data,
        headers: {
          ...headers,
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response.data;
    } catch (error) {
      // check if the error is a 401 error
      if (error.response && error.response.status === 401) {
        try {
          accessToken = refreshAccessToken();
          const retryRequest = await axios({
            url: `${api_url}${url}`,
            method,
            data,
            headers: {
              ...headers,
              Authorization: `Bearer ${accessToken}`,
            },
          });
          return retryRequest.data;
        } catch (refreshError) {
          
          throw refreshError;
        }
      } else {
        throw error;
      }
    }
  };

  return { requestWithAuth };
};
